import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const VerifyEmailApi = createAsyncThunk('/master-user/verify-emaill', async (requestHeaders, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${ROOT_URL}/master-user/verify-email?key=${requestHeaders}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        // body: JSON.stringify(requestHeaders),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const verifyEmail = createSlice(
  {
    name: 'verifyEmail',
    initialState,
    reducers: {},
    extraReducers: {
      [VerifyEmailApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [VerifyEmailApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [VerifyEmailApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default verifyEmail;
